export default __webpack_public_path__ + "static/media/GoodMannersOnThePhone_13.873b79c7.png";